/**
 * Format a points value (e.g. `5.5`, `12`, `2.50`) for compact display.
 *
 * Rules:
 *   - Integers render without a decimal point: `5 → "5"`, `0 → "0"`.
 *   - Non-integers render with up to 2 decimal places, stripping a trailing
 *     zero only if it's the second decimal: `2.5 → "2.5"`, `2.50 → "2.5"`,
 *     `2.55 → "2.55"`.
 *   - NaN / Infinity coerced to `"0"`.
 *
 * Single source of truth — used by MatchPreviewCard, MatchDetailCard,
 * PredictionsTable. Keeps the "+5.5 pts" rendering identical across surfaces.
 */
export const formatPoints = (raw: number | string | null | undefined): string => {
  if (raw === null || raw === undefined) return '0';
  const n = typeof raw === 'number' ? raw : parseFloat(String(raw));
  if (!Number.isFinite(n)) return '0';
  const rounded = Math.round(n * 100) / 100;
  if (Number.isInteger(rounded)) return rounded.toString();
  // toFixed(2) yields "2.50" for 2.5; trim a single trailing zero so we
  // render "2.5" not "2.50", but keep "2.55" intact.
  return rounded.toFixed(2).replace(/0$/, '').replace(/\.$/, '');
};
